import action from '../helpers/rest-client'
import {
  EditCompanyOutDto,
  GetOneCompanyOutDto,
} from '../types/company.dto'

export class ErrorCompany extends Error { }

const path = '/company'

class Company {
  public async edit({ idCompany, body }: EditCompanyOutDto) {
    // if (body['logo-small'] && !(body['logo-small'] as MediaDto)?.key) {
    //   const file = body['logo-small'] as File
    //   body['logo-small'] = await services.media.upload(file)
    // }

    // if (body['logo-big'] && !(body['logo-big'] as MediaDto)?.key) {
    //   const file = body['logo-big'] as File
    //   body['logo-big'] = await services.media.upload(file)
    // }

    return action
      .Patch({
        url: `${path}/${idCompany}`,
        body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idCompany }: GetOneCompanyOutDto) {

    return action
      .Get({
        url: `${path}/${idCompany}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getBySlug({ slugCompany }: GetOneCompanyOutDto) {
    return action
      .Get({
        url: `${path}/slug/${slugCompany}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const company = new Company()
export default company
